import React, {useEffect, useState} from 'react'
import {useHistory} from "react-router-dom";
import '../base/Theme.css';
import './Profile.css';
import Input from "../base/input/Input";
import Button from "../base/button/Button";
import Loader from "../base/loader/Loader";
import Toolbar from "../base/toolbar/Toolbar";
import Space from "../base/space/Space";
import firebase from 'firebase/app';
import 'firebase/auth';
import {Players} from "../../firebase/Collections";
import {mapToPlayer} from "../../firebase/Mappers";
import {showError, showSuccess} from "../base/toaster/CustomToaster";
import Back from "../base/back/Back";
import {updateProfile} from "../../data/Api";

function Profile() {
    const history = useHistory();
    const [player, setPlayer] = useState(null);
    const [name, setName] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        watchPlayer();
    }, [])

    const watchPlayer = () => {
        firebase.auth().onAuthStateChanged(function (user) {
            if (!user) {
                history.push("/login");
            } else {
                firebase.firestore()
                    .collection(Players.NAME)
                    .doc(user.uid)
                    .onSnapshot((doc) => {
                        const player = mapToPlayer(doc);
                        setPlayer(player);
                        setName(player?.name);
                    });
            }
        });
    }

    const onNameChanged = (name) => {
        setName(name);
    }

    const onSaveClick = async () => {
        setLoading(true);
        try {
            await updateProfile(name);
            showSuccess("Success.");
        } catch (e) {
            showError(e.response.data);
        }
        setLoading(false);
    }

    if (!player || loading) {
        return <div className={"Root"}><Loader/></div>
    }

    return (
        <div className="Root">
            <div className="Content">
                <Toolbar title={"Profile"} leftButton={<Back/>}/>
                <Input type="text" placeholder={"Name"} text={name} onTextChanged={onNameChanged}
                       onEnterPressed={onSaveClick}/>
                <Space space={16}/>
                <Button text={"Save"} onClick={onSaveClick}/>
            </div>
        </div>
    );
}

export default Profile;
